import { useQuery } from 'react-query';
import { SORT_DIRECTION } from '../../../interfaces/enumerables';
import { InvoiceInList } from '../../../interfaces/invoice.interface';
import { GetEntities } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';

const getSalesWithMark = async (
  customerId: string,
  page: number,
  currentDocAadeCode?: string,
): Promise<GetEntities<InvoiceInList>> => {
  const resp = await apiRQ.get<GetEntities<InvoiceInList>>('/invoices', {
    params: {
      page,
      customerId,
      correlations: true,
      orderBy: 'createdAt',
      order: SORT_DIRECTION.DESC,
      ...(currentDocAadeCode ? { correlationForDocType: currentDocAadeCode } : {}),
    },
  });
  return resp.data;
};

export const useSalesWithMark = (customerId: string, page: number, currentDocAadeCode?: string) => {
  return useQuery<GetEntities<InvoiceInList>, Error>(
    ['getSalesWithMark', customerId, page, currentDocAadeCode],
    () => getSalesWithMark(customerId, page, currentDocAadeCode),
    {
      enabled: !!customerId,
      cacheTime: 2000,
      staleTime: 2000,
      retry: 2,
    },
  );
};
